export default __webpack_public_path__ + "static/marbel-0bc5037ac564110ed0323e032dcd53d6.jpg";